<template>
  <div>
    <b-row>
      <b-col md="12">
        <b-card class="card-itens tableItensCompra compra-xml-table">
          <!-- CAMPO DE PERCENTUAL + AVISO -->
          <b-row class="compra-itens-toolbar-row">
            <b-col cols="12" class="d-flex justify-content-end align-items-center flex-wrap">
              <div class="compra-itens-toolbar">
                <template v-if="selectedIndexes.length > 0">
                  <b-button
                    size="sm"
                    variant="outline-secondary"
                    @click="handleOpenGrupoCompraBulk"
                    v-b-tooltip.hover.bottom="'Definir grupo para os itens selecionados'"
                  >
                    Grupo em massa
                  </b-button>
                  <b-button
                    size="sm"
                    variant="outline-secondary"
                    @click="handleOpenPerfilTributarioCompraBulk"
                    v-b-tooltip.hover.bottom="'Definir perfil tributário para os itens selecionados'"
                  >
                    Perfil tributário em massa
                  </b-button>
                  <b-button
                    size="sm"
                    variant="outline-secondary"
                    @click="handleOpenTipoProdutoCompraBulk"
                    v-b-tooltip.hover.bottom="'Definir tipo de produto para os itens selecionados'"
                  >
                    Tipo do produto em massa
                  </b-button>
                </template>
                <b-input-group size="sm" class="compra-markup">
                  <b-form-input v-model.number="markupPercent" type="number" min="0" step="0.01"
                    placeholder="% markup sobre o custo" />
                  <b-input-group-append>
                    <b-button variant="success" @click="aplicarMarkup">
                      Aplicar
                    </b-button>
                  </b-input-group-append>
                </b-input-group>

                <b-icon icon="info-circle" variant="primary" class="compra-markup-info" v-b-tooltip.left="'Informe o percentual de markup que será aplicado sobre o custo atual dos itens selecionados para formar o novo preço de venda.'
                  " />
              </div>
            </b-col>
          </b-row>
          <!-- FIM BLOCO -->

          <div class="compra-xml-table-scroll" role="region" aria-label="Itens da nota XML" tabindex="0">
          <table class="table table-head-custom table-head-bg table-vertical-center compra-itens-tabela" :key="keyToRender">
            <colgroup><col /><col /><col /><col /><col /><col /><col /></colgroup>
            <thead>
              <tr>
                <!-- COLUNA SELECIONAR TODOS -->
                <th style="width: 30px; text-align: center;">
                  <b-form-checkbox v-model="selectAll" :indeterminate="isIndeterminate" aria-label="Selecionar todos os itens"
                    @change="handleToggleSelectAll" />
                </th>

                <!-- COLUNA NUMERAÇÃO / CÓDIGO -->
                <th scope="col">Nº / Código</th>

                <th class="pl-0 font-weight-bold text-muted pl-7">
                  Itens Nota
                </th>
                <th class="pl-0 font-weight-bold text-muted pl-7">
                  Custo Últ.Compra
                </th>
                <th class="pl-0 font-weight-bold text-muted pl-7">
                  Custo Atual
                </th>
                <th class="pl-0 font-weight-bold text-muted pl-7">
                  Preço Venda
                  <b-icon icon="info-circle" variant="primary" v-b-tooltip.left="'Caso preencher o preço de venda o mesmo já irá atualizar no seu estoque'
                    "></b-icon>
                </th>
                <th>Ações</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(i, index) in items" :key="'item' + index">
                <!-- CHECKBOX POR LINHA -->
                <td data-label="Selecionar" class="text-center">
                  <b-form-checkbox v-model="selectedIndexes" :value="index" :aria-label="`Selecionar item ${index + 1}`" />
                </td>

                <!-- NUMERAÇÃO / CÓDIGO -->
                <td data-label="Nº / Código">
                  {{ parseFloat(index + 1) }} /
                  <strong style="font-size: 10px">
                    {{ i.cod_importacao }}
                  </strong>
                </td>

                <!-- COLUNA ITENS NOTA -->
                <td class="pl-0 compra-item-descricao" data-label="Itens Nota">
                  <div>
                    <!-- Produto NOVO: input + chip "Novo" lado a lado -->
                    <template v-if="!i.vinculo">
                      <div class="item-desc">
                        <b-form-input size="sm" :id="`desc-${index}`" v-model="i.produto.descricao"
                          :maxlength="120" placeholder="Descrição do produto (novo)" autocomplete="off" trim
                          @blur="onDescricaoBlur(i)" @keydown.enter.prevent="focusNext(index)" />
                        <span class="chip chip--info" v-b-tooltip.hover.right
                          :title="'Produtos não vinculados serão cadastrados no sistema como produtos novos. Se você já tem esse produto cadastrado, clique em “Vincular” e faça o vínculo com esse item.'">
                          Novo
                        </span>
                      </div>
                    </template>

                    <!-- Vinculado: texto + chip "Vinculado" e referência do produto -->
                    <template v-else>
                      <div class="item-desc">
                        <span class="mb-0">{{ i.produto.descricao }}</span>
                        <span class="chip chip--success">Vinculado</span>
                      </div>
                      <span class="text-muted" style="font-size: 12px">
                        {{ i.vinculoProduto.codigo }} -
                        {{ i.vinculoProduto.descricao }}
                      </span>
                      <div
                        v-if="i.vinculoProduto.lote"
                        class="d-flex align-items-center flex-wrap mt-2"
                        style="gap: 6px"
                      >
                        <b-button
                          size="sm"
                          :variant="i.lote_baixa ? 'outline-success' : 'outline-warning'"
                          @click="abrirLoteCompra(i, index)"
                        >
                          {{ i.lote_baixa ? "Alterar lote" : "Selecionar lote" }}
                        </b-button>
                        <span v-if="i.lote_baixa" class="chip chip--success">
                          Lote: {{ i.lote_baixa.numero_lote }}
                        </span>
                        <span v-else class="text-warning font-weight-bold">
                          Lote obrigatório
                        </span>
                      </div>
                    </template>
                    <div v-if="!i.vinculo" class="item-config-actions mt-2">
                      <div class="item-config-action">
                        <b-button
                          type="button"
                          size="sm"
                          variant="outline-secondary"
                          @click="handleOpenGrupoCompra(i, index)"
                          v-b-tooltip.hover.top="getGrupoCompraTooltip(i)"
                        >
                          {{ getGrupoCompraLabel(i) }}
                        </b-button>
                        <b-button
                          v-if="i.grupo_compra"
                          type="button"
                          size="sm"
                          variant="link"
                          class="p-0 text-danger"
                          @click="limparGrupoItem(i)"
                          v-b-tooltip.hover.top="'Remover grupo'"
                        >
                          <b-icon icon="x-circle" />
                        </b-button>
                      </div>
                      <div class="item-config-action">
                        <b-button
                          type="button"
                          size="sm"
                          variant="outline-secondary"
                          @click="handleOpenPerfilTributarioCompra(i, index)"
                          v-b-tooltip.hover.top="getPerfilTributarioCompraTooltip(i)"
                        >
                          {{ getPerfilTributarioCompraLabel(i) }}
                        </b-button>
                        <b-button
                          v-if="i.perfil_tributario_compra"
                          type="button"
                          size="sm"
                          variant="link"
                          class="p-0 text-danger"
                          @click="limparPerfilTributarioItem(i)"
                          v-b-tooltip.hover.top="'Remover perfil tributário'"
                        >
                          <b-icon icon="x-circle" />
                        </b-button>
                      </div>
                      <div class="item-config-action">
                        <b-button
                          :id="`tipo-produto-item-${index}`"
                          type="button"
                          size="sm"
                          variant="outline-secondary"
                          @click="handleOpenTipoProdutoCompra(i, index)"
                          v-b-tooltip.hover.top="getTipoProdutoCompraTooltip(i)"
                        >
                          {{ getTipoProdutoCompraLabel(i) }}
                        </b-button>
                        <b-button
                          v-if="i.id_tipo != null"
                          type="button"
                          size="sm"
                          variant="link"
                          class="p-0 text-danger"
                          aria-label="Remover alteração do tipo do produto"
                          @click="limparTipoProdutoItem(i)"
                          v-b-tooltip.hover.top="'Remover alteração do tipo do produto'"
                        >
                          <b-icon icon="x-circle" />
                        </b-button>
                      </div>
                    </div>
                  </div>
                </td>
                <!-- FIM COLUNA ITENS NOTA -->

                <td class="compra-item-valor" data-label="Custo Últ.Compra">
                  <money disabled v-if="i.vinculo" class="form-control" :value="parseFloat(i.custo_ultima_compra)"
                    @input="(value) => (i.custo_ultima_compra = value)" v-bind="priceOptions"></money>
                </td>

                <td class="compra-item-valor" data-label="Custo Atual">
                  <div class="custo-atual-cell">
                    <div class="custo-atual-field">
                      <money
                        disabled
                        class="form-control"
                        :value="parseFloat(i.custo)"
                        @input="(value) => (i.custo = value)"
                        v-bind="priceOptions"
                      ></money>
                    </div>
                    <span
                      class="custo-composicao-trigger"
                      role="button"
                      tabindex="0"
                      aria-label="Ver composição do custo atual"
                      v-b-tooltip.hover.focus.right.html="
                        getCustoComposicaoTooltip(i)
                      "
                    >
                      <b-icon icon="eye" />
                    </span>
                    <b-icon
                      v-if="hasCustoVariacao(i)"
                      :icon="getCustoVariacaoIcon(i)"
                      :class="['custo-variacao-icon', getCustoVariacaoClass(i)]"
                      v-b-tooltip.hover.right="getCustoVariacaoTooltip(i)"
                    />
                  </div>
                </td>

                <td class="compra-item-valor" data-label="Preço Venda">
                  <money v-if="!i.vinculo" class="form-control" :value="parseFloat(i.preco)"
                    @input="(value) => (i.preco = value)" v-bind="priceOptions"></money>
                  <money :disabled="i.vinculoProduto && i.vinculoProduto.markup > 0" v-else class="form-control"
                    :value="parseFloat(i.vinculoProduto.preco)" @input="(value) => (i.vinculoProduto.preco = value)"
                    v-bind="priceOptions"></money>
                </td>

                <td data-label="Ações">
                  <b-button type="button" size="sm" variant="primary" class="compra-vinculo-button" @click="handleOpenVinculo(i, index)">
                    {{ !i.vinculo ? "Vincular" : "Desvincular" }}
                  </b-button>
                </td>
              </tr>
            </tbody>
          </table>
          </div>
        </b-card>
      </b-col>
    </b-row>

    <LoteProdutoModal
      :produto="produtoLoteSelecionado"
      :compra="true"
      :quantidade="quantidadeLoteSelecionada"
      :preco="precoLoteSelecionado"
      :bloquearQuantidade="true"
      :atualizarLotes="atualizarLotes"
      @onAddProduto="onAddProdutoFromLote"
      @onClose="fecharLoteCompra"
    />

    <b-modal id="vincular-itens" title="Vincular/Desvincular item" size="md" centered>
      <h5 style="text-align: center; margin-bottom: 2rem">
        Busque o produto que deseja vincular com o item:
        <span style="font-weight: normal">
          {{ produtoParaVincular && produtoParaVincular.descricao }}
        </span>
      </h5>

      <VueSelect ref="buscarProduto" :filterable="false" :options="produtos" @search="onSearchProduto"
        @input="handleSelectProduto" :value="produtoParaVincular && produtoParaVincular.vinculoProduto"
        v-if="produtoParaVincular" :disabled="produtoParaVincular && produtoParaVincular.vinculoProduto">
        <template slot="no-options"> Informe a descrição do produto </template>

        <template slot="option" slot-scope="option">
          <div class="d-center">
            {{ option.codigo }} - {{ option.descricao }}
          </div>
        </template>

        <template slot="selected-option" slot-scope="option">
          <div class="selected d-center">
            {{ option.codigo }} - {{ option.descricao.slice(0, 30) }}
          </div>
        </template>
      </VueSelect>

      <template #modal-footer="{ ok, cancel }">
        <b-button @click="
          () => {
            cancel();
          }
        ">Cancelar</b-button>
        <b-button v-if="vinculoProduto" variant="danger" ref="desvincular-button" @click="
          () => {
            desvincularItem();
            ok();
          }
        ">
          Desvincular
        </b-button>
        <b-button variant="success" v-if="!vinculoProduto" ref="vincular-button" @click="
          () => {
            vincularItem();
            ok();
          }
        ">
          Vincular
        </b-button>
      </template>
    </b-modal>

    <b-modal
      id="selecionar-grupo-compra"
      :title="isBulkModeGrupo ? 'Definir grupo em massa' : 'Grupo do produto novo'"
      size="md"
      centered
    >
      <h5 style="text-align: center; margin-bottom: 2rem">
        <template v-if="isBulkModeGrupo">
          Selecione o grupo para
          <span style="font-weight: normal">{{ selectedIndexes.length }} item(ns) selecionado(s)</span>
        </template>
        <template v-else>
          Selecione o grupo para:
          <span style="font-weight: normal">
            {{ descricaoItemConfiguracaoCompra }}
          </span>
        </template>
      </h5>

      <VueSelect
        ref="buscarGrupoCompra"
        :filterable="false"
        :options="gruposCompra"
        @open="onSearchGrupoCompra"
        @search="onSearchGrupoCompra"
        v-model="grupoCompraSelecionado"
        :clearable="true"
      >
        <template slot="no-options"> Informe o nome do grupo </template>

        <template slot="option" slot-scope="option">
          <div class="d-center">
            {{ option.nome }}
          </div>
        </template>

        <template slot="selected-option" slot-scope="option">
          <div class="selected d-center">
            {{ option.nome }}
          </div>
        </template>
      </VueSelect>

      <template #modal-footer="{ ok, cancel }">
        <b-button type="button" @click="cancel()">Cancelar</b-button>
        <b-button
          type="button"
          variant="outline-danger"
          @click="limparGrupoCompra(ok)"
        >
          Limpar
        </b-button>
        <b-button
          type="button"
          variant="success"
          @click="salvarGrupoCompra(ok)"
        >
          Aplicar
        </b-button>
      </template>
    </b-modal>

    <b-modal
      id="selecionar-perfil-tributario-compra"
      :title="isBulkModePerfilTributario ? 'Definir perfil tributário em massa' : 'Perfil tributário do produto novo'"
      size="md"
      centered
    >
      <h5 style="text-align: center; margin-bottom: 2rem">
        <template v-if="isBulkModePerfilTributario">
          Selecione o perfil tributário para
          <span style="font-weight: normal">{{ selectedIndexes.length }} item(ns) selecionado(s)</span>
        </template>
        <template v-else>
          Selecione o perfil tributário para:
          <span style="font-weight: normal">
            {{ descricaoItemConfiguracaoCompra }}
          </span>
        </template>
      </h5>

      <VueSelect
        ref="buscarPerfilTributarioCompra"
        :filterable="false"
        :options="perfisTributariosCompra"
        @open="onSearchPerfilTributarioCompra"
        @search="onSearchPerfilTributarioCompra"
        v-model="perfilTributarioCompraSelecionado"
        :clearable="true"
      >
        <template slot="no-options">
          Informe a descrição do perfil tributário
        </template>

        <template slot="option" slot-scope="option">
          <div class="d-center">
            {{ option.descricao }}
          </div>
        </template>

        <template slot="selected-option" slot-scope="option">
          <div class="selected d-center">
            {{ option.descricao }}
          </div>
        </template>
      </VueSelect>

      <template #modal-footer="{ ok, cancel }">
        <b-button type="button" @click="cancel()">Cancelar</b-button>
        <b-button
          type="button"
          variant="outline-danger"
          @click="limparPerfilTributarioCompra(ok)"
        >
          Limpar
        </b-button>
        <b-button
          type="button"
          variant="success"
          @click="salvarPerfilTributarioCompra(ok)"
        >
          Aplicar
        </b-button>
      </template>
    </b-modal>
    <b-modal
      id="selecionar-tipo-produto-compra"
      :title="isBulkModeTipoProduto ? 'Definir tipo do produto em massa' : 'Tipo do produto'"
      size="md"
      centered
    >
      <h5 style="text-align: center; margin-bottom: 2rem">
        <template v-if="isBulkModeTipoProduto">
          Selecione o tipo para
          <span style="font-weight: normal">{{ selectedIndexes.length }} item(ns) selecionado(s)</span>
        </template>
        <template v-else>
          Selecione o tipo para:
          <span style="font-weight: normal">
            {{ descricaoItemConfiguracaoCompra }}
          </span>
        </template>
      </h5>

      <b-form-group label="Tipo do produto" label-for="tipo-produto-itens-compra">
        <b-form-select
          id="tipo-produto-itens-compra"
          v-model="tipoProdutoCompraSelecionado"
          :disabled="carregandoTiposProdutoCompra"
        >
          <b-form-select-option :value="null">
            {{ isBulkModeTipoProduto || (itemConfiguracaoCompra && itemConfiguracaoCompra.vinculoProduto)
              ? 'Manter tipo atual / padrão do cadastro'
              : 'Padrão do cadastro' }}
          </b-form-select-option>
          <b-form-select-option
            v-for="tipo in tiposProdutoCompra"
            :key="tipo.id"
            :value="tipo.id"
          >
            {{ tipo.descricao }}
          </b-form-select-option>
        </b-form-select>
      </b-form-group>

      <template #modal-footer="{ ok, cancel }">
        <b-button type="button" @click="cancel()">Cancelar</b-button>
        <b-button
          type="button"
          variant="outline-danger"
          @click="limparTipoProdutoCompra(ok)"
        >
          Limpar
        </b-button>
        <b-button
          type="button"
          variant="success"
          :disabled="carregandoTiposProdutoCompra"
          @click="salvarTipoProdutoCompra(ok)"
        >
          Aplicar
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import _ from "lodash";
import { SistemaMixin } from "@/modules/Application";
import VueSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import { Money } from "v-money";
import { priceOptions } from "@/modules/Application";
import { mapActions } from "vuex";
import LoteProdutoModal from "@/components/LoteProdutoModal";
import {
  atribuirLoteAoItemCompra,
  indicePrimeiroLotePendente,
} from "../../loteCompra";

export default {
  name: "compra-card-itens",
  components: {
    VueSelect,
    Money,
    LoteProdutoModal,
  },
  mixins: [SistemaMixin],
  data() {
    return {
      calculoTotal: 0,
      produtos: [],
      priceOptions,
      produtoParaVincular: null,
      itemConfiguracaoCompra: null,
      itemConfiguracaoCompraIndex: null,
      gruposCompra: [],
      perfisTributariosCompra: [],
      grupoCompraSelecionado: null,
      perfilTributarioCompraSelecionado: null,
      tiposProdutoCompra: [],
      tipoProdutoCompraSelecionado: null,
      carregandoTiposProdutoCompra: false,
      isBulkModeGrupo: false,
      isBulkModePerfilTributario: false,
      isBulkModeTipoProduto: false,
      keyToRender: 0,
      selectedItem: 0,
      vinculoProduto: null,
      produtoLoteSelecionado: null,
      itemLoteIndex: null,
      quantidadeLoteSelecionada: 1,
      precoLoteSelecionado: 0,
      atualizarLotes: 0,

      // Percentual de markup
      markupPercent: null,

      // Seleção de itens
      selectedIndexes: [],
      selectAll: false,

    };
  },
  props: {
    items: {
      default: [],
    },
    total: {
      default: 0,
    },
    ativo: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    descricaoItemConfiguracaoCompra() {
      return this.itemConfiguracaoCompra?.produto?.descricao || "";
    },
    // estado indeterminado do "selecionar todos"
    isIndeterminate() {
      return (
        this.selectedIndexes.length > 0 &&
        this.selectedIndexes.length < this.items.length
      );
    },
  },
  created() {
    this.carregarTiposProdutoCompra();
  },
  methods: {
    ...mapActions(["setLoading"]),

    abrirLoteCompra(item, index) {
      if (!item?.vinculoProduto?.lote) return;

      this.itemLoteIndex = index;
      this.produtoLoteSelecionado = { ...item.vinculoProduto };
      this.quantidadeLoteSelecionada = parseFloat(
        item.quantidade_conversao ?? item.quantidade ?? 1
      ) || 1;
      this.precoLoteSelecionado = parseFloat(item.custo ?? item.preco ?? 0) || 0;
      this.atualizarLotes++;
    },

    onAddProdutoFromLote({ newProduto }) {
      const item = this.items[this.itemLoteIndex];
      if (!item || !newProduto?.lote_baixa) return;

      const itemAtualizado = atribuirLoteAoItemCompra(
        item,
        newProduto.lote_baixa
      );

      this.$set(item, "lote", itemAtualizado.lote);
      this.$set(item, "lote_baixa", itemAtualizado.lote_baixa);
      this.$emit("onItemsChange", this.items);

      this.$nextTick(() => this.solicitarLotePendente());
    },

    fecharLoteCompra() {
      this.produtoLoteSelecionado = null;
      this.itemLoteIndex = null;
    },

    solicitarLotePendente() {
      if (!this.ativo || this.produtoLoteSelecionado) return;

      const index = indicePrimeiroLotePendente(this.items);

      if (index >= 0) {
        this.abrirLoteCompra(this.items[index], index);
      }
    },

    getGrupoCompraLabel(item) {
      const nome = item?.grupo_compra?.nome;
      return nome ? `Grupo: ${this.truncateConfigLabel(nome)}` : "Grupo";
    },

    getGrupoCompraTooltip(item) {
      return item?.grupo_compra?.nome || "Configurar grupo do produto novo";
    },

    getPerfilTributarioCompraLabel(item) {
      const descricao = item?.perfil_tributario_compra?.descricao;
      return descricao
        ? `Perfil: ${this.truncateConfigLabel(descricao)}`
        : "Perfil tributário";
    },

    getPerfilTributarioCompraTooltip(item) {
      return (
        item?.perfil_tributario_compra?.descricao ||
        "Configurar perfil tributário do produto novo"
      );
    },

    getTipoProdutoCompraTooltip(item) {
      const idTipo = item?.id_tipo ?? item?.vinculoProduto?.id_tipo;
      const tipo = this.tiposProdutoCompra.find(
        (tipo) => Number(tipo.id) === Number(idTipo)
      );
      return tipo?.descricao || (idTipo == null ? "Configurar tipo do produto" : String(idTipo));
    },

    getTipoProdutoCompraLabel(item) {
      const idTipo = item?.id_tipo ?? item?.vinculoProduto?.id_tipo;
      return idTipo == null
        ? "Tipo do produto"
        : `Tipo: ${this.truncateConfigLabel(this.getTipoProdutoCompraTooltip(item))}`;
    },

    async carregarTiposProdutoCompra() {
      if (this.tiposProdutoCompra.length || this.carregandoTiposProdutoCompra) return;
      this.carregandoTiposProdutoCompra = true;
      try {
        const { data } = await this.$http.post("/produtos/tipos");
        this.tiposProdutoCompra = data;
      } catch {
        this.$toast.error("Não foi possível carregar os tipos de produto.");
      } finally {
        this.carregandoTiposProdutoCompra = false;
      }
    },

    handleOpenTipoProdutoCompra(item, index) {
      this.isBulkModeTipoProduto = false;
      this.itemConfiguracaoCompra = item;
      this.itemConfiguracaoCompraIndex = index;
      const idTipo = item.id_tipo ?? item.vinculoProduto?.id_tipo;
      this.tipoProdutoCompraSelecionado = idTipo == null ? null : Number(idTipo);
      this.carregarTiposProdutoCompra();
      this.$bvModal.show("selecionar-tipo-produto-compra");
    },

    handleOpenTipoProdutoCompraBulk() {
      this.isBulkModeTipoProduto = true;
      this.itemConfiguracaoCompra = null;
      this.itemConfiguracaoCompraIndex = null;
      this.tipoProdutoCompraSelecionado = null;
      this.carregarTiposProdutoCompra();
      this.$bvModal.show("selecionar-tipo-produto-compra");
    },

    limparTipoProdutoItem(item) {
      this.$delete(item, "id_tipo");
      this.$emit("onItemsChange", this.items);
    },

    salvarTipoProdutoCompra(done) {
      const indices = this.isBulkModeTipoProduto
        ? this.selectedIndexes
        : [this.itemConfiguracaoCompraIndex];
      const idTipo = this.tipoProdutoCompraSelecionado;
      indices.forEach((index) => {
        const item = this.items[index];
        if (!item) return;
        if (idTipo == null || Number(idTipo) === Number(item.vinculoProduto?.id_tipo)) {
          this.$delete(item, "id_tipo");
        } else {
          this.$set(item, "id_tipo", Number(idTipo));
        }
      });
      this.isBulkModeTipoProduto = false;
      this.$emit("onItemsChange", this.items);
      done();
    },

    limparTipoProdutoCompra(done) {
      this.tipoProdutoCompraSelecionado = null;
      this.salvarTipoProdutoCompra(done);
    },

    truncateConfigLabel(value) {
      if (!value) return "";
      return value.length > 18 ? `${value.slice(0, 18)}...` : value;
    },

    limparGrupoItem(item) {
      this.$set(item, "id_grupo", null);
      this.$set(item, "grupo_compra", null);
      this.$emit("onItemsChange", this.items);
    },

    limparPerfilTributarioItem(item) {
      this.$set(item, "id_perfil_tributario", null);
      this.$set(item, "perfil_tributario_compra", null);
      this.$emit("onItemsChange", this.items);
    },

    handleOpenGrupoCompra(item, index) {
      this.isBulkModeGrupo = false;
      this.itemConfiguracaoCompra = item;
      this.itemConfiguracaoCompraIndex = index;
      this.grupoCompraSelecionado = item?.grupo_compra || null;
      this.gruposCompra = item?.grupo_compra ? [item.grupo_compra] : [];
      this.$bvModal.show("selecionar-grupo-compra");
    },

    handleOpenPerfilTributarioCompra(item, index) {
      this.isBulkModePerfilTributario = false;
      this.itemConfiguracaoCompra = item;
      this.itemConfiguracaoCompraIndex = index;
      this.perfilTributarioCompraSelecionado =
        item?.perfil_tributario_compra || null;
      this.perfisTributariosCompra = item?.perfil_tributario_compra
        ? [item.perfil_tributario_compra]
        : [];
      this.$bvModal.show("selecionar-perfil-tributario-compra");
    },

    handleOpenGrupoCompraBulk() {
      this.isBulkModeGrupo = true;
      this.itemConfiguracaoCompra = null;
      this.itemConfiguracaoCompraIndex = null;
      this.grupoCompraSelecionado = null;
      this.gruposCompra = [];
      this.$bvModal.show("selecionar-grupo-compra");
    },

    handleOpenPerfilTributarioCompraBulk() {
      this.isBulkModePerfilTributario = true;
      this.itemConfiguracaoCompra = null;
      this.itemConfiguracaoCompraIndex = null;
      this.perfilTributarioCompraSelecionado = null;
      this.perfisTributariosCompra = [];
      this.$bvModal.show("selecionar-perfil-tributario-compra");
    },

    salvarGrupoCompra(done) {
      const grupo = this.grupoCompraSelecionado;

      if (this.isBulkModeGrupo) {
        this.selectedIndexes.forEach((idx) => {
          const item = this.items[idx];
          if (!item) return;
          this.$set(item, "id_grupo", grupo?.id ?? null);
          this.$set(
            item,
            "grupo_compra",
            grupo ? { id: grupo.id, nome: grupo.nome } : null
          );
        });
        this.isBulkModeGrupo = false;
        this.$emit("onItemsChange", this.items);
        done();
        return;
      }

      if (this.itemConfiguracaoCompraIndex === null) return;

      const item = this.items[this.itemConfiguracaoCompraIndex];

      this.$set(item, "id_grupo", grupo?.id ?? null);
      this.$set(
        item,
        "grupo_compra",
        grupo ? { id: grupo.id, nome: grupo.nome } : null
      );
      this.$emit("onItemsChange", this.items);
      done();
    },

    limparGrupoCompra(done) {
      this.grupoCompraSelecionado = null;
      this.salvarGrupoCompra(done);
    },

    salvarPerfilTributarioCompra(done) {
      const perfil = this.perfilTributarioCompraSelecionado;

      if (this.isBulkModePerfilTributario) {
        this.selectedIndexes.forEach((idx) => {
          const item = this.items[idx];
          if (!item) return;
          this.$set(item, "id_perfil_tributario", perfil?.id ?? null);
          this.$set(
            item,
            "perfil_tributario_compra",
            perfil ? { id: perfil.id, descricao: perfil.descricao } : null
          );
        });
        this.isBulkModePerfilTributario = false;
        this.$emit("onItemsChange", this.items);
        done();
        return;
      }

      if (this.itemConfiguracaoCompraIndex === null) return;

      const item = this.items[this.itemConfiguracaoCompraIndex];

      this.$set(item, "id_perfil_tributario", perfil?.id ?? null);
      this.$set(
        item,
        "perfil_tributario_compra",
        perfil ? { id: perfil.id, descricao: perfil.descricao } : null
      );
      this.$emit("onItemsChange", this.items);
      done();
    },

    limparPerfilTributarioCompra(done) {
      this.perfilTributarioCompraSelecionado = null;
      this.salvarPerfilTributarioCompra(done);
    },

    onSearchGrupoCompra(search, loading) {
      const busca = this.prepararBuscaDireta(search, loading);
      busca.loading(true);
      this.searchGrupoCompra(busca.loading, busca.termo, this);
    },

    searchGrupoCompra: _.debounce(async (loading, search, vm) => {
      const grupos = await vm.getGrupoByDescricao(search);
      vm.gruposCompra = grupos.slice(0, 20);
      loading(false);
    }, 350),

    onSearchPerfilTributarioCompra(search, loading) {
      const busca = this.prepararBuscaDireta(search, loading);
      busca.loading(true);
      this.searchPerfilTributarioCompra(busca.loading, busca.termo, this);
    },

    searchPerfilTributarioCompra: _.debounce(async (loading, search, vm) => {
      const perfis = await vm.getPerfilTributarioByDescricao(search);
      vm.perfisTributariosCompra = perfis.slice(0, 20);
      loading(false);
    }, 350),

    // Normaliza descrição e emite alteração para o pai
    onDescricaoBlur(i) {
      const raw = i?.produto?.descricao || "";
      const normalized = raw.replace(/\s+/g, " ").trim().toUpperCase();
      i.produto.descricao = normalized;
      this.$emit("onItemsChange", this.items);
    },

    // Enter foca no próximo input de descrição
    focusNext(idx) {
      const next = this.$el.querySelector(`#desc-${idx + 1}`);
      if (next) next.focus();
    },

    // Arredonda 2 casas
    roundMoeda(value) {
      if (value === null || value === undefined || value === "") return 0;
      const num = parseFloat(value);
      if (isNaN(num)) return 0;
      return Math.round(num * 100) / 100;
    },

    toCustoNumber(value) {
      const number = parseFloat(value);
      return Number.isFinite(number) ? number : 0;
    },

    getCustoComposicao(item) {
      const quantidade = this.toCustoNumber(item?.quantidade) || 1;
      const custoCompra = this.toCustoNumber(
        item?.preco_original ?? item?.preco
      );
      const frete = this.toCustoNumber(item?.vFrete) / quantidade;
      const ipi = this.toCustoNumber(item?.vIPI) / quantidade;
      const outrasDespesas = this.toCustoNumber(item?.vOutro);
      const icmsSt = Object.prototype.hasOwnProperty.call(item || {}, "VICMSST")
        ? this.toCustoNumber(item.VICMSST)
        : this.toCustoNumber(item?.VICMSSTtotal) / quantidade;
      const descontos = -this.toCustoNumber(item?.vDesc) / quantidade;
      const custoAtual = this.toCustoNumber(item?.custo);
      const componentes = [
        { label: "Custo de compra", value: custoCompra },
        { label: "Frete / transporte", value: frete },
        { label: "IPI", value: ipi },
        { label: "ICMS ST", value: icmsSt },
        { label: "Outras despesas", value: outrasDespesas },
        { label: "Descontos", value: descontos },
      ];
      const subtotal = componentes.reduce(
        (total, componente) => total + componente.value,
        0
      );
      const ajuste = custoAtual - subtotal;
      const precision = Number(priceOptions.precision) || 2;
      const tolerancia = 0.5 / Math.pow(10, precision);

      if (Math.abs(ajuste) >= tolerancia) {
        componentes.push({ label: "Conversão / ajustes", value: ajuste });
      }

      return { componentes, custoAtual };
    },

    formatCustoComposicao(value, showSignal = true) {
      const number = this.toCustoNumber(value);
      const precision = Number(priceOptions.precision) || 2;
      const formatted = Math.abs(number).toLocaleString("pt-BR", {
        minimumFractionDigits: precision,
        maximumFractionDigits: precision,
      });

      if (!showSignal) return `R$ ${formatted}`;
      return `${number < 0 ? "−" : "+"} R$ ${formatted}`;
    },

    getCustoComposicaoTooltip(item) {
      const { componentes, custoAtual } = this.getCustoComposicao(item);
      const linhas = componentes
        .map(
          ({ label, value }) => `
            <div class="custo-composicao-tooltip__row">
              <span>${label}</span>
              <strong>${this.formatCustoComposicao(value)}</strong>
            </div>
          `
        )
        .join("");

      return `
        <div class="custo-composicao-tooltip">
          <div class="custo-composicao-tooltip__title">
            Composição do custo unitário
          </div>
          ${linhas}
          <div class="custo-composicao-tooltip__row custo-composicao-tooltip__total">
            <span>Custo atual</span>
            <strong>${this.formatCustoComposicao(custoAtual, false)}</strong>
          </div>
        </div>
      `;
    },

    getCustoVariacaoPercentual(item) {
      const custoAtual = parseFloat(item?.custo);
      const custoUltimaCompra = parseFloat(item?.custo_ultima_compra);

      if (
        !isFinite(custoAtual) ||
        !isFinite(custoUltimaCompra) ||
        custoUltimaCompra <= 0
      ) {
        return 0;
      }

      return ((custoAtual - custoUltimaCompra) / custoUltimaCompra) * 100;
    },

    hasCustoVariacao(item) {
      return this.roundMoeda(this.getCustoVariacaoPercentual(item)) !== 0;
    },

    getCustoVariacaoIcon(item) {
      return this.getCustoVariacaoPercentual(item) > 0
        ? "arrow-up"
        : "arrow-down";
    },

    getCustoVariacaoClass(item) {
      return this.getCustoVariacaoPercentual(item) > 0
        ? "custo-variacao-icon--up"
        : "custo-variacao-icon--down";
    },

    formatPercentualCusto(value) {
      return Math.abs(value).toLocaleString("pt-BR", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },

    getCustoVariacaoTooltip(item) {
      const percentual = this.getCustoVariacaoPercentual(item);
      const label = percentual > 0 ? "Aumento" : "Redução";
      return `${label} de ${this.formatPercentualCusto(
        percentual
      )}% desde a última compra`;
    },

    // Selecionar / desmarcar todos
    handleToggleSelectAll(checked) {
      if (checked) {
        this.selectedIndexes = this.items.map((_, idx) => idx);
      } else {
        this.selectedIndexes = [];
      }
    },

    // Aplica o markup somente nos itens selecionados
    async aplicarMarkup() {
      if (this.markupPercent === null || this.markupPercent === "") {
        this.$toast.warning("Informe um percentual para aplicar.");
        return;
      }

      const perc = parseFloat(this.markupPercent);
      if (isNaN(perc)) {
        this.$toast.error("Percentual inválido.");
        return;
      }

      if (!this.selectedIndexes.length) {
        this.$toast.warning(
          "Selecione ao menos um item na tabela para aplicar o markup."
        );
        return;
      }

      const qtd = this.selectedIndexes.length;

      // Confirmação
      const confirmed = await this.$bvModal.msgBoxConfirm(
        `Será aplicado um markup de ${perc}% sobre o custo atual de ${qtd} item(ns) selecionado(s). Deseja continuar?`,
        {
          title: "Confirmar aplicação de markup",
          size: "md",
          buttonSize: "sm",
          okVariant: "success",
          okTitle: "Sim, aplicar",
          cancelTitle: "Cancelar",
          footerClass: "p-2",
          centered: true,
        }
      );

      if (!confirmed) return;

      const fator = 1 + perc / 100;

      this.selectedIndexes.forEach((idx) => {
        const i = this.items[idx];
        if (!i) return;

        const custoBase = parseFloat(i.custo) || 0;
        if (!custoBase || custoBase <= 0) {
          return; // pula itens sem custo
        }

        const novoPreco = this.roundMoeda(custoBase * fator);

        // Produto sem vínculo -> usa i.preco
        if (!i.vinculo) {
          i.preco = novoPreco;
          return;
        }

        // Produto vinculado -> usa vinculoProduto.preco
        if (i.vinculo && i.vinculoProduto) {
          // Se quiser pular quem já tem markup cadastrado:
          // if (i.vinculoProduto.markup > 0) return;

          i.vinculoProduto.preco = novoPreco;
          i.vinculoProduto.markup = perc; // opcional
        }
      });

      this.$emit("onItemsChange", this.items);
      this.$toast.success(
        `Markup de ${this.markupPercent}% aplicado sobre o custo atual de ${qtd} item(ns) selecionado(s).`
      );

      // 👉 limpa seleção após aplicar
      this.selectedIndexes = [];
      this.selectAll = false;
    },


    async vincularItem() {
      if (!this.produtoParaVincular) {
        this.$toast.warning("Selecione um produto para vincular!");
        return;
      }
      this.setLoading(true);
      try {
        const data = {};
        data.codigo_importacao = this.produtoParaVincular.cod_importacao;
        data.id = this.produtoParaVincular.vinculoProduto?.id ?? null;
        await this.$http.post("/produtos/vincular-produto", data);
        this.items[this.produtoParaVincular.index].vinculo = true;
        this.items[this.produtoParaVincular.index].vinculoProduto =
          this.produtoParaVincular.vinculoProduto;
        this.$emit("onItemsChange", this.items);
        this.$toast.success("Produto vinculado com sucesso!");
        this.keyToRender = this.keyToRender + 1;

        if (this.produtoParaVincular.vinculoProduto?.lote) {
          this.$nextTick(() =>
            this.abrirLoteCompra(
              this.items[this.produtoParaVincular.index],
              this.produtoParaVincular.index
            )
          );
        }
      } catch (error) {
        console.log(error);
      }
      this.setLoading(false);
    },

    async desvincularItem() {
      if (!this.produtoParaVincular) {
        this.$toast.warning("Este item não possui vínculo!");
        return;
      }
      this.setLoading(true);
      try {
        const data = {};
        data.codigo_importacao = null;
        data.id = this.produtoParaVincular?.vinculoProduto?.id ?? null;
        await this.$http.post("/produtos/desvincular-produto", data);
        this.items[this.produtoParaVincular.index].vinculo = false;
        this.items[this.produtoParaVincular.index].vinculoProduto = null;
        this.$toast.success("Produto desvinculado com sucesso!");
        this.keyToRender = this.keyToRender + 1;
        this.$emit("onItemsChange", this.items);
        this.produtoParaVincular = null;
      } catch (error) {
        console.log(error);
      }
      this.setLoading(false);
    },

    handleOpenVinculo(produto, index) {
      this.selectedItem = index;
      this.produtoParaVincular = {
        ...produto,
        index,
        descricao: produto.produto.descricao,
      };
      this.vinculoProduto = !!produto?.vinculoProduto;
      this.$bvModal.show("vincular-itens");
    },

    handleSelectProduto(produto) {
      this.produtoParaVincular = {
        ...this.produtoParaVincular,
        vinculoProduto: produto,
      };
    },

    onSearchProduto(search, loading) {
      if (search.length) {
        loading(true);
        this.searchProduto(loading, search, this);
      }
    },

    searchProduto: _.debounce(async (loading, search, vm) => {
      vm.produtos = await vm.getProdutoByDescricao(search);
      loading(false);
    }, 350),

    valorReal(valor = 0) {
      return valor.toLocaleString("pt-br", {
        minimumFractionDigits: 2,
      });
    },
  },
  watch: {
    ativo(value) {
      if (value) {
        this.$nextTick(() => this.solicitarLotePendente());
      }
    },
    total(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.calculoTotal = newValue;
      }
    },
    // Mantém o "selecionar todos" em sincronia com a seleção manual
    selectedIndexes(newVal) {
      if (!this.items.length) {
        this.selectAll = false;
        return;
      }
      if (newVal.length === this.items.length) {
        this.selectAll = true;
      } else if (newVal.length === 0) {
        this.selectAll = false;
      }
    },
  },
};
</script>

<style>
.compra-itens-toolbar-row {
  margin-bottom: 6px;
}

.compra-vinculo-button.btn {
  padding: 6px 10px;
  font-size: 12px;
  line-height: 1.25;
  white-space: nowrap;
}

.compra-itens-toolbar {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 6px;
  width: 100%;
  min-width: 0;
}

.compra-itens-toolbar > .btn {
  flex: 0 1 auto;
  min-width: 0;
  white-space: normal;
}

.compra-itens-toolbar .compra-markup {
  flex: 0 1 260px;
  width: auto;
  min-width: 140px;
  max-width: 260px;
}

.compra-markup-info {
  flex: 0 0 auto;
}

/* ====== ajustes de layout para input + selo ====== */
.item-desc {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: nowrap;
  min-width: 0;
}

.item-desc .form-control {
  flex: 1 1 0;
  width: 0;
  min-width: 0;
}

.item-desc .chip {
  flex: 0 0 auto;
}

.item-desc > span:not(.chip) {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.item-config-actions {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: nowrap;
  width: 100%;
  min-width: 0;
}

.item-config-action {
  display: flex;
  align-items: center;
  gap: 2px;
  flex: 1 1 0;
  min-width: 0;
}

.item-config-action:only-child {
  flex: 0 1 150px;
}

.item-config-actions .btn {
  min-width: 0;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.item-config-action > .btn:first-child {
  flex: 1 1 0;
  width: 0;
  padding-right: 6px;
  padding-left: 6px;
  font-size: 11px;
}

.item-config-action > .btn-link {
  flex: 0 0 auto;
}

/* Chip genérico */
.chip {
  display: inline-flex;
  align-items: center;
  padding: 0 10px;
  height: 22px;
  line-height: 22px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 500;
  white-space: nowrap;
  border: 1px solid transparent;
}

.chip--info {
  color: #17a2b8;
  border-color: #17a2b8;
  background: rgba(23, 162, 184, 0.06);
}

.chip--success {
  color: #28a745;
  border-color: #28a745;
  background: rgba(40, 167, 69, 0.06);
}

.custo-atual-cell {
  display: flex;
  align-items: center;
  gap: 8px;
}

.custo-atual-field {
  flex: 1 1 auto;
  min-width: 0;
}

.custo-composicao-trigger {
  display: inline-flex;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  color: var(--color-primary);
  font-size: 17px;
  cursor: help;
}

.custo-composicao-trigger:focus {
  outline: 2px solid rgba(54, 153, 255, 0.35);
  outline-offset: 2px;
  border-radius: 2px;
}

.tooltip .tooltip-inner:has(.custo-composicao-tooltip) {
  max-width: 290px;
  padding: 0;
}

.custo-composicao-tooltip {
  width: 270px;
  padding: 12px 14px;
  text-align: left;
}

.custo-composicao-tooltip__title {
  margin-bottom: 8px;
  font-weight: 600;
  text-align: center;
}

.custo-composicao-tooltip__row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 3px 0;
}

.custo-composicao-tooltip__row strong {
  white-space: nowrap;
}

.custo-composicao-tooltip__total {
  margin-top: 6px;
  padding-top: 8px;
  border-top: 1px solid rgba(255, 255, 255, 0.35);
}

.custo-variacao-icon {
  flex: 0 0 auto;
  font-size: 16px;
  cursor: help;
}

.custo-variacao-icon--up {
  color: #f64e60;
}

.custo-variacao-icon--down {
  color: #28a745;
}

/* ====== originais (mantidos) ====== */
.produtoBusca .vs__dropdown-menu {
  width: 700px;
  left: -200px !important;
}

.card-titulo-itens .card-title {
  margin-bottom: 0 !important;
  font-weight: 700;
  font-size: 1.75rem;
  padding: 0.75rem;
}

.card-titulo-itens .card-body {
  padding: 0.45rem;
}

.card-titulo-itens {
  background-color: #fff;
  border: 0px;
  text-align: center;
  margin-bottom: 0px;
  padding: 0;
  border-bottom-left-radius: 0px;
  border-bottom-right-radius: 0px;
}

.card-itens .card-body {
  padding: 0;
}

.table {
  border-bottom: solid 0px #dedede;
  margin-bottom: 0px;
}

.tableItensCompra {
  border: 0px;
  border-top-left-radius: 0px;
  border-top-right-radius: 0px;
}

.tableItensCompra th,
.tableItensCompra td {
  padding: 8px 16px;
}

.tableItensCompra .table tr th {
  border-bottom: 2px solid var(--color-primary);
}

.tableItensCompra th {
  position: sticky;
  top: 0;
  background: #fff;
}

::-webkit-scrollbar {
  width: 5px;
}

::-webkit-scrollbar-thumb {
  background: transparent;
  border-radius: 1px;
}

::-webkit-scrollbar-track {
  box-shadow: inset 0 0 200px rgb(229 245 234 / 19%);
  border-radius: 10px;
}

::-webkit-scrollbar-thumb:hover {
  background: var(--color-secondary);
}

.card-total-venda {
  background: transparent;
  border: 0px;
  top: 30px;
}

.card-total-venda .card-body {
  padding: 0rem 1rem 0rem 1rem;
}

.card-total-left {
  background-color: var(--color-primary);
  border-color: var(--color-primary);
  color: #fff;
  border-radius: 0px;
  border-bottom-left-radius: 20px !important;
  height: 90px;
  width: 101%;
  display: table;
  text-align: left;
}

.card-total-left .card-body {
  display: table-cell;
  vertical-align: middle;
}

.card-total-right {
  background-color: var(--color-secondary);
  border-color: var(--color-secondary);
  color: #fff;
  border-radius: 0px;
  align-items: flex-end;
  border-bottom-right-radius: 20px !important;
  height: 90px;
  width: 100%;
  display: table;
  text-align: center;
  text-align: right;
}

.card-total-right .card-body {
  display: table-cell;
  vertical-align: middle;
}

.card-total-right p,
.card-total-left p {
  margin-bottom: 0;
  font-size: 0.8rem;
}

.card-total-right h5,
.card-total-left h5 {
  font-size: 1.75rem !important;
  margin-bottom: 0;
}

.tableItensCompra tbody tr {
  border-top-width: 1.5px;
  border-top-color: var(--color-primary);
}

blockquote {
  margin: 0 auto;
  position: relative;
  text-align: center;
  z-index: 1;
}

blockquote:after {
  content: "";
  display: block;
  position: absolute;
  width: 100%;
  height: 29px;
  right: 0;
  bottom: -24px;
  left: 0;
  padding-top: 10px;
  background: linear-gradient(-45deg, transparent 70%, white 75%),
    linear-gradient(45deg, transparent 70%, white 75%);
  background-repeat: repeat-x;
  background-size: 25px 20px, 25px 20px;
  background-position: center;
}
</style>
